import { render, staticRenderFns } from "./EndpointList.vue?vue&type=template&id=1c04ea32&"
import script from "./EndpointList.vue?vue&type=script&lang=js&"
export * from "./EndpointList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports